/**
 * Created by Shai Zelman on 10/03/2020.
 */

import {Component, ChangeDetectionStrategy, Input, Output, EventEmitter, ViewChild, TemplateRef, OnDestroy, HostBinding} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {PopupWindowService} from "../../services/popup.window.service";
import {takeUntilDestroy} from "take-until-destroy";

@Component({
	selector: "pp-page-header",
	templateUrl: './page.header.component.html',
	styleUrls: ['./page.header.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageHeaderComponent implements OnDestroy {
	@Input() titleToTranslate: string;
	@Input() titleWithoutTranslation: string;
	@Input() iconClass: string;

	@Output() backClick: EventEmitter<null> = new EventEmitter<null>();
	@Output() closeClick: EventEmitter<null> = new EventEmitter<null>();

	@ViewChild('closePopupContent', {static: false}) closePopupContent: TemplateRef<any>;
	@ViewChild('closePopupTitle', {static: false}) closePopupTitle: TemplateRef<any>;

	@HostBinding("class.hide-back") @Input() hideBack = false;
	@HostBinding("class.hide-close") @Input() hideClose = false;

	constructor(public router: Router, public route: ActivatedRoute, public popupWindowService: PopupWindowService) {

	}

	public backClickHandler() {
		this.backClick.emit();
	}

	public closeClickHandler() {
		this.popupWindowService.openPopupWindow(this.closePopupContent, this.closePopupTitle, "close-title", window.outerWidth - 20, 190).pipe(takeUntilDestroy(this))
			.subscribe((result) => {
				if (result === true) {
					this.closeClick.emit();
				}
			});
	}

	ngOnDestroy(): void {

	}
}
